<template>
    <div class="invasionBox" style="padding-top: 140px">
        <div class="cl topBox">
            <div class="fl col-sm-3 col-xs-4">
                <div class="leftImageBox">
                    <img src="../../assets/images/GameofKings.png" alt="" width="100%">
                </div>
            </div>
            <div class="fl col-sm-9 col-xs-8">
                <div class="chanpinNameBox">
                    <div class="name">{{ $t('lang.business.invasion.a1') }}</div>
                    <div class="nameEn">{{ $t('lang.business.gameOfKings.name') }}</div>
                </div>
                <div class="kaifashang">
                    <div class="name">{{ $t('lang.business.invasion.a2') }}</div>
                    <div class="nameEn">{{ $t('lang.business.gameOfKings.kaifashang') }}</div>
                </div>
            </div>
        </div>
        <div class="describe">
            <div class="title cl">
                <span class="tip fl"></span>
                <span class="fl">{{ $t('lang.business.invasion.a3') }}</span>
            </div>
            <div class="detail">{{ $t('lang.business.gameOfKings.a4') }}</div>
        </div>
        <div class="describe">
            <div class="title cl">
                <span class="tip fl"></span>
                <span class="fl">{{ $t('lang.business.invasion.a5') }}</span>
            </div>
            <div class="detail">{{ $t('lang.business.gameOfKings.a5') }}</div>
        </div>
        <div class="describe">
            <div class="title cl">
                <span class="tip fl"></span>
                <span class="fl">{{ $t('lang.business.invasion.a7') }}</span>
            </div>
            <div class="detail">
                <span class="jiantou" style="margin-right: 15px"><img src="../../../static/img/jt.png" alt="" style="width: 7px;margin-top: -4px;margin-left: 8px;"></span>
                <span class="text">{{ $t('lang.business.gameOfKings.a6') }}</span></div>
        </div>
        <!--作品展示-->
        <div class="worksShow">
            <div class="titleBox">
                <div class="title">{{$t('lang.homePage.zpzs')}}</div>
            </div>
            <LunboView :daImage="daImage"></LunboView>
        </div>
    </div>
</template>

<script>
    import LunboView from '../views/lunboView'
    export default {
        name: "warfare",
        components: {
            LunboView
        },
        data() {
            return {
                daImage:[
                    'static/img/红警/红警-PC-1.png',
                    'static/img/红警/红警-PC-2.png',
                    'static/img/红警/红警-PC-3.png',
                    'static/img/红警/红警-PC-4.png',
                    'static/img/红警/红警-PC-5.png',
                ]
            }
        },
        mounted(){
            document.getElementsByTagName('html')[0].scrollTop=0;
            // window.location.reload();
        }
    }
</script>


<style>
    .invasionBox{
        width: 80%;
        margin: 0 auto;
        padding: 60px 0 80px;
    }
    .invasionBox .leftImageBox{
        width: 154px;
        height: 154px;
        border-radius: 33px;
        background: #bdbcb5;
        overflow: hidden;
    }
    .invasionBox .topBox{
        margin-bottom: 90px;
    }
    .invasionBox .topBox .name{
        font-size: 20px;
        font-weight: 400;
        color: #000000;
        margin-bottom: 13px;
        line-height: 20px;
    }
    .invasionBox .topBox .nameEn{
        font-size: 30px;
        font-weight: bold;
        color: #000000;
        line-height: 20px;
    }
    .invasionBox .topBox .chanpinNameBox{
        border-bottom:  2px solid #000;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }
    .invasionBox .describe{
        margin-bottom: 100px;
    }
    .invasionBox .describe .title{
        font-size: 25px;
        font-weight: bold;
        margin-bottom: 30px;
        line-height: 35px;
    }
    .invasionBox .describe .title .tip{
        display: inline-block;
        width: 10px;
        height: 28px;
        margin-top: 5px;
        margin-right: 20px;
        background: #000;
    }
    .invasionBox .describe .detail{
        font-size: 20px;
        color: #000;
        line-height: 40px;
    }
    @media (max-width: 992px){
        .invasionBox .leftImageBox{
            width: 120px;
            height: 120px;
            border-radius: 28px;
            background: #bdbcb5;
        }
        .invasionBox .topBox .name{
            font-size: 18px;
            font-weight: 400;
            color: #000000;
            margin-bottom: 5px;
            line-height: 20px;
        }
        .invasionBox .topBox .nameEn{
            font-size: 30px;
            font-weight: bold;
            color: #000000;
            line-height: 20px;
        }
        .invasionBox .topBox .chanpinNameBox {
            border-bottom: 2px solid #000;
            padding-bottom: 15px;
            margin-bottom: 15px;
        }
    }
    @media (max-width: 768px){
        .invasionBox{
            width: 90%;
        }
        .invasionBox .leftImageBox{
            width: 100px;
            height: 100px;
            border-radius: 20px;
            background: #bdbcb5;
        }
        .invasionBox .topBox .name{
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            margin-bottom: 0px;
            line-height: 20px;
        }
        .invasionBox .topBox .nameEn{
            font-size: 20px;
            font-weight: bold;
            color: #000000;
            line-height: 20px;
        }
        .invasionBox .topBox .chanpinNameBox {
            border-bottom: 2px solid #000;
            padding-bottom: 10px;
            margin-bottom: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/product/gameOfKings.vue